// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3JjmU","input":"style_input__2XPXZ","form":"style_form__2GG_q","column":"style_column__1tBlU","warning":"style_warning__-i1ce"};